import React from "react"
import AppPillToggle from "./PillToggle"

const ALL = 'all'

const OPTIONS = [
	{ value: 'Enabled', label: 'Enabled' },
	{ value: 'Disabled', label: 'Disabled' },
	{ value: ALL, label: 'All' },
]

// A table's Off/On filter (one value, or none for all) as a selector next to its title instead of a filter chip
export default function AppStatusFilterToggle({ filter = [], onChange, ...props }) {
	const value = filter.length === 1 ? filter[0] : ALL

	return <AppPillToggle
		size="small"
		{...props}
		value={value}
		options={OPTIONS}
		onChange={option => onChange(option === ALL ? [] : [option])}
	/>
}
